import { api } from "./client";
import type { DashboardSummary } from "./types";

/**
 * The one read the Home screen makes.
 *
 * No parameters, by design rather than by omission: the summary is the same
 * question every time, so there is no filter to send, nothing for a caller to
 * steer a query with, and nothing about the request that could be got wrong.
 *
 * Home used to answer its own questions by fetching a hundred product rows and
 * counting them in the browser, which was wrong past a hundred products and
 * silent about it. Counting orders the same way is not merely wasteful but
 * impossible without disclosure: the smallest page the admin orders endpoint
 * serves is one row, and a row carries a customer's name and phone number.
 * This returns integers.
 */
export const dashboardApi = {
  summary: (signal?: AbortSignal) =>
    api.get<DashboardSummary>("/admin/dashboard/summary", undefined, signal),
};
